import { SprintMutationResult, useSprintMutation, useSprintQueryClient } from "sprint-common-web";

import { useAssetsApi } from "../../../../../common/api/master-api/assets/useAssetsApi";
import { CloudAssetQueryKey } from "../../../cloud-asset/common/CloudAssetQueryKey";
import { OnPremAssetQueryKey } from "../../../on-prem-asset/common/OnPremAssetQueryKey";

interface DeprecateCloudAssetParams {
    contentVersionIds: string[];
}

interface UseDeprecateCloudAsset {
    deprecateCloudAssetGroup: SprintMutationResult<DeprecateCloudAssetParams>;
    deprecateOnPremAssetGroup: SprintMutationResult<DeprecateCloudAssetParams>;
}

export const useDeprecateAssetGroup = ({ invalidationKey }: { invalidationKey?: string }): UseDeprecateCloudAsset => {
    const { deprecateCloudAssetGroup, deprecateOnPremAssetGroup } = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    const deprecateCloud = useSprintMutation<DeprecateCloudAssetParams>({
        mutationFn: async ({ contentVersionIds }: DeprecateCloudAssetParams) => {
            await deprecateCloudAssetGroup({ contentVersionIds });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudAssetQueryKey.CloudAssetDetails, invalidationKey]
            });
        }
    });

    const deprecateOnPrem = useSprintMutation<DeprecateCloudAssetParams>({
        mutationFn: async ({ contentVersionIds }: DeprecateCloudAssetParams) => {
            await deprecateOnPremAssetGroup({ contentVersionIds });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [OnPremAssetQueryKey.OnPremAssetDetails, invalidationKey]
            });
        }
    });

    return { deprecateCloudAssetGroup: deprecateCloud, deprecateOnPremAssetGroup: deprecateOnPrem };
};
